/* Code Clubs: the little the pages need beyond HTML. Every page reads fully without
   this script; it only opens and closes the phone menu. */
const menuBtn = document.querySelector('.menu');
const menu = document.getElementById('menu');
if (menuBtn && menu) {
  menuBtn.addEventListener('click', () => {
    const open = menu.classList.toggle('open');
    menuBtn.setAttribute('aria-expanded', String(open));
  });
}
